import { Color, Spacing, TextInput, TextInputProps } from 'zens-storybook'
import React, { useCallback, useState } from 'react'
import { FlatList, ListRenderItem, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { GeoResult, Place, useStore } from 'zens-store'
import { debounce } from '@dms/helper'

import Result from './result'

const styles = StyleSheet.create({
  list: {
    borderColor: Color.calmGrey,
    borderWidth: 1,
    paddingVertical: Spacing.XS,
  },
})

interface Props extends Omit<TextInputProps, 'style' | 'onChange'> {
  style?: StyleProp<ViewStyle>
  onChange?: (place?: Place) => void
}
const GeoInput = (props: Props) => {
  const { style, onChange } = props
  const { geo } = useStore()
  const [results, setResults] = useState<GeoResult[]>([])

  const search = useCallback(
    debounce(async (value: string) => {
      if (value.length >= 3 && !geo.searchPlace.inProgress) {
        setResults(await geo.searchPlace(value))
      } else {
        setResults([])
      }
    }, 600),
    [],
  )

  const update = (value: string) => {
    search(value)
  }

  const select = (result: GeoResult) => async () => {
    const place = await geo.getPlace(result.placeId)
    onChange?.(place)
  }

  const renderResult: ListRenderItem<GeoResult> = (info) => {
    const { item } = info
    return <Result result={item} onPress={select(item)} testID="GeoInput.Row" />
  }

  return (
    <View style={style}>
      <TextInput onChangeText={update} left="marker" testID="GeoInput.TextInput" />
      <FlatList data={results} renderItem={renderResult} contentContainerStyle={results.length > 0 && styles.list} />
      <View nativeID="map" />
    </View>
  )
}

export default GeoInput
